import makeStyles from "@material-ui/core/styles/makeStyles";

const useCardStyles = makeStyles(theme => ({
    root: {
        width: 255,
        height: 205,
        boxShadow: "0px 4px 16px rgba(72, 72, 72, 0.08)",
        borderRadius: "4px",
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "150%",
    },
    media: {
        height: 56,
        width: 56,
        objectFit: "contain"
    },
    smallMedia: {
        height: 24,
        width: 24,
        objectFit: "contain"
    },
    mediaWidget: {
        height: 34,
        width: 34,
    },
    mediaWidgetStar: {
        height: 24,
        width: 24,
    },
    fakeCard: {
        width: 255,
        height: 205,
        boxShadow: "0px 4px 16px rgba(72, 72, 72, 0.08)",
        borderRadius: "4px",
        background: "#484848",
        backgroundColor: 'transparent',
        // opacity: 0.01,
    },
    mailContentCard: {
        width: 635,
        boxShadow: "0px 4px 16px rgba(72, 72, 72, 0.08)",
        borderRadius: "4px",
        backgroundColor: "#ffffff"
    },
    mailPreviewCard: {
        width: 445,
        height: 499,
        boxShadow: "0px 4px 16px rgba(72, 72, 72, 0.08)",
        borderRadius: "4px",
        backgroundColor: "#ffffff"
    },
    landingPageContentCard: {
        width: 635,
        minHeight: 625,
        boxShadow: "0px 4px 16px rgba(72, 72, 72, 0.08)",
        borderRadius: "4px",
        backgroundColor: "#ffffff"
    },
    shadow: {
        boxShadow: "0px 4px 16px rgba(72, 72, 72, 0.08)",
    },
    supportCard: {
        width: 635,
        height: 540,
        boxShadow: "0px 4px 16px rgba(72, 72, 72, 0.08)",
        borderRadius: "4px",
        backgroundColor: "#ffffff"
    },
    landingPageUploadCard: {
        width: 350,
        height: 260,
        boxShadow: "0px 4px 16px rgba(72, 72, 72, 0.08)",
        borderRadius: "4px",
        backgroundColor: "#ffffff"
    },
    sendWhatsapp: {
        width: 900,
        boxShadow: "0px 4px 16px rgba(72, 72, 72, 0.08)",
        borderRadius: "4px",
        backgroundColor: "#ffffff"
    },
    sendMailOrSMSCard: {
        width: 659,
        boxShadow: "0px 4px 16px rgba(72, 72, 72, 0.08)",
        borderRadius: "4px",
        backgroundColor: "#ffffff"
    }, sentRequestTable: {
        width: 1100,
        height: 249,
        boxShadow: "0px 4px 16px rgba(72, 72, 72, 0.08)",
        borderRadius: "4px",
        backgroundColor: "#ffffff"
    },
    accountDetailsCard: {
        width: 540,
        height: 794,
        boxShadow: "0px 4px 16px rgba(72, 72, 72, 0.08)",
        borderRadius: "4px",
        backgroundColor: "#ffffff"
    },
    subscriptionCard: {
        width: 400,
        boxShadow: "0px 4px 16px rgba(72, 72, 72, 0.08)",
        borderRadius: "4px",
        backgroundColor: "#ffffff"
    },
    widgetCard: {
        '@media(max-width:1000px)': {
            '& .widget': {
                width: '100%',
                marginLeft: 0,
            }
        }
    },
    reviewCard: {
        width: "100%",
        color: theme.card.color,
        background: theme.card.background,
        boxShadow: "0px 4px 8px rgba(72, 72, 72, 0.16)",
        borderRadius: "4px",
        marginBottom: 30,
        height: '214px',
        position: "relative",
        " & .providerLogo": {
            width: 16,
            height: 16,
            position: "absolute",
            top: 12,
            right: 12
        },
        " & .providerLogoPopUp": {
            width: 16,
            height: 16,
        }
    },
    socialTemplateCard: {
        width: 1110,
        height: 480,
        boxShadow: "0px 4px 16px rgba(72, 72, 72, 0.08)",
        borderRadius: "4px",
        backgroundColor: "#ffffff"
    },
    templateCard: {
        marginRight: "30px",
        "& .template": {
            cursor: "pointer",
            width: 320,
            paddingTop: "100%",
            backgroundColor: "#f6f6f6",
            borderRadius: "4px",
            position: "relative",
            backgroundPosition: "center",
            backgroundSize: "cover",
            "& p": {
                color: "#484848",
                position: "absolute",
                opacity: 0.5,
                textAlign: "center",
                top: "50%",
                left: "50%",
                transform: "translate(-50%,-50%)"
            },
            "& svg": {
                position: "absolute",
                top: "10px",
                right: "10px"
            }
        }
    },
    scheduledPostCard: {
        width: 255,
        height: 377,
        "& .template": {
            width: 207,
            height: 207,
            border: '1px solid rgba(72, 72, 72, 0.1)',
            borderRadius: 4
        },
        '& .topText': {
            padding: '0',
            whiteSpace: 'nowrap',
            textOverflow: "ellipsis",
            overflow: 'hidden',
            display: 'block'
        },
        boxShadow: '0px 4px 16px rgba(72, 72, 72, 0.08)',
        background: 'white',
    },
    selectedTemplateCard: {
        border: "2px solid #27CC89 !important",
    },
    notSelectedTemplateCard: {
        border: "2px solid transparent",
    },
    content: {
        color: "#484848",
        opacity: 1.0,
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "150%",
        textAlign: "center",
    },
    stats: {
        borderRadius: 4,
        boxShadow: '0px 4px 16px rgba(72, 72, 72, 0.08);',
        width: '100%',
        height: '100%',
        background: 'white',
        padding: '15px 28px 15px 28px',
        '& .lightText': {
            color: theme.palette.text.primary,
            opacity: 0.5
        },
        '& .statsText': {
            fontSize: 36,
            fontWeight: 'bold',
            marginRight: 10,
            lineHeight: '28px',
        }
    },
    toast: {
        minWidth: 202,
        position: "fixed",
        top: 24,
        left: "50%",
        zIndex: 9999,
        transform: "translateX(-50%)",
        "& .message": {
            textAlign: "center",
            paddingLeft: "30px",
            boxSizing: "content-box",
            width: "100%"
        },
        padding: "17px 16px 17px 16px",
        boxShadow: "0px 4px 16px rgba(72, 72, 72, 0.08)",
        borderRadius: 4,
        "& .material-icons": {
            position: "absolute",
            left: 16
        }
    },
    textCard: {
        background: "white",
        boxShadow: "0px 2px 4px rgba(72, 72, 72, 0.08)",
        borderRadius: 4,
        padding: 15,
        width: "fit-content",
        textAlign: "center"
    },
    genericCard: {
        color: theme.card.color,
        background:  theme.card.background,
        boxShadow: '0px 4px 16px rgba(72, 72, 72, 0.08)',
        borderRadius: '4px',
        padding: 24,
    },
    badgeCard: {
        color: theme.card.color,
        background: theme.card.background,
        boxShadow: "0px 4px 8px rgba(72, 72, 72, 0.16)",
        borderRadius: '4px',
        padding: 12,
        width:100,
        transformOrigin: 'top left',
        right: 0,
        top: '50%',
       // transform: 'scale(0.8,0.8)',
        [theme.breakpoints.down('sm')]: {
        //    transform: 'scale(0.6,0.6)',
        },
    },
    bordCard: {
        padding: 16,
        border: "1px solid rgba(72, 72, 72, 0.1)",
        borderRadius: "8px",
    },
    underLineCard: {
        borderBottom: '#ededed solid 1px'
    },
    smTop: {
        paddingTop: '12px',
    },
    smBottom: {
        paddingBottom: '12px',
    },
    shareImage: {
        background: '#FFFFFF',
        width: '540px',
        height: '540px',
        '& h1': {
            fontWeight: 'normal',
            textAlign: 'center',
            fontSize: '24px',
            whiteSpace: ' pre-wrap'
        }
    },
    feedCard: {
        "& :nth-child(odd)": {
            background: "#F6F6F6",
        }
    },
    resendCard: {
        borderRadius: 4,
        width: 400,
        overflow: "hidden",
        boxShadow: "0px 4px 16px rgba(72, 72, 72, 0.08)",
        background: '#FFFFFF',
        '& .header': {
            padding: '24px 24px 12px 24px',
            borderBottom: '1px rgba(72, 72, 72,0.1) solid',
        },
        '& .footer': {
            padding: '22px 24px 24px 24px'
        }
    },
    qrCard: {
        width: '350px',
        height: '350px',
        padding: '20px',
        background: '#FFFFFF',
        position: 'fixed',
        top: 0,
        left: '-350px',
        borderRadius: 4,
        '& img': {
            width: 87
        }
    },
    ReviewCardPopUp: {
        color: theme.card.color,
        background: theme.card.background,
        boxShadow: "0px 4px 8px rgba(72, 72, 72, 0.16)",
        borderRadius: "4px",
        height: 'auto',
        " & .providerLogoPopUp": {
            width: 16,
            height: 16,
        },
        width: '100%',
    },
    tableReview: {
        overflow: 'visible',
        minWidth: 500,
        // minWidth: 300,
        '@media(max-width:1450px)': {
            minWidth: 200,
        }
    }
}), {index: 1});

export {useCardStyles}
